/* ==========================================================================
   Plant Store <> UnfoldCRO — Frequently bought together

   Keeps the total, the saving and the button label in step with the ticks,
   then adds every ticked line in ONE /cart/add.js call so the cart drawer
   opens once instead of once per product.

   If a bundle % discount is set (theme setting), it overrides the per-item
   compare-at math: the strikethrough becomes the raw sale-price sum, and the
   total is that minus the bundle percentage. Applies whatever the source of
   the lines is (static, collection, or Selleasy pre-adopt).
   ========================================================================== */
(function () {
  'use strict';

  function initFbt(root) {
    if (!root || root.dataset.ufcBound) return;
    root.dataset.ufcBound = 'true';

    var strings = {};
    try {
      strings = JSON.parse(root.querySelector('[data-ufc-fbt-strings]')?.textContent || document.querySelector('[data-ufc-fbt-strings]').textContent);
    } catch (e) {
      strings = { copied: 'Copied!' };
    }

    var totalEl = root.querySelector('[data-ufc-fbt-total]');
    var compareEl = root.querySelector('[data-ufc-fbt-compare]');
    var labelEl = root.querySelector('[data-ufc-fbt-label]');
    var saveEl = root.querySelector('[data-ufc-fbt-save]');
    var button = root.querySelector('[data-ufc-fbt-add]');
    var discountPercent = parseFloat(root.getAttribute('data-ufc-fbt-discount-percent')) || 0;

    function items() {
      return root.querySelectorAll('[data-ufc-fbt-item]');
    }

    function checked() {
      return Array.prototype.filter.call(items(), function (input) {
        return input.checked;
      });
    }

    function sync() {
      var picked = checked();
      var total = 0;
      var compare = 0;

      picked.forEach(function (input) {
        total += Number(input.dataset.price) || 0;
        compare += Number(input.dataset.compare) || 0;
      });

      if (discountPercent > 0) {
        compare = total;
        total = Math.round(total * (100 - discountPercent) / 100);
      }

      if (totalEl) totalEl.textContent = money(total, strings.moneyFormat);

      if (compareEl) {
        var hasSaving = compare > total;
        compareEl.hidden = !hasSaving;
        if (hasSaving) compareEl.textContent = money(compare, strings.moneyFormat);
      }

      if (saveEl && strings.save) {
        var saving = compare - total;
        saveEl.hidden = saving <= 0;
        if (saving > 0) {
          saveEl.textContent = strings.save.split('[amount]').join(money(saving, strings.moneyFormat));
        }
      }

      if (labelEl) labelEl.textContent = strings.total.split('[count]').join(picked.length);
      if (button) {
        button.textContent = strings.button.split('[count]').join(picked.length);
        button.disabled = picked.length === 0;
      }
    }

    function money(cents, format) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return String(format || '{{amount}}')
        .replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/g, function () {
          return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        })
        .replace(/<[^>]+>/g, '');
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-ufc-fbt-variant-select]')) {
        var select = e.target;
        var line = select.closest('.ufc-fbt__line');
        if (!line) return;

        var opt = select.options[select.selectedIndex];
        var input = line.querySelector('[data-ufc-fbt-item]');
        var priceEl = line.querySelector('[data-ufc-fbt-price-display]');

        if (input && opt) {
          input.dataset.variant = opt.value;
          input.dataset.price = opt.dataset.price;
          input.dataset.compare = opt.dataset.compare;
        }
        if (priceEl && opt) priceEl.textContent = opt.dataset.priceDisplay;

        sync();
        return;
      }

      if (e.target.matches('[data-ufc-fbt-item]')) sync();
    });

    var lines = root.querySelector('.ufc-fbt__lines');
    if (lines && window.MutationObserver) {
      new MutationObserver(sync).observe(lines, { childList: true });
    }

    // --- COPY CODE LOGIC ---
    // --- COPY CODE LOGIC ---
    var copyBtn = root.querySelector('[data-ufc-fbt-copy-code]');
    if (copyBtn) {
      var copyLabelEl = root.querySelector('[data-ufc-fbt-copy-label]');
      var copyResetTimer;
      var originalText = copyLabelEl ? copyLabelEl.textContent : '';

      function showCopied() {
        if (!copyLabelEl) return;
        copyLabelEl.textContent = strings.copied || 'Copied!';

        window.clearTimeout(copyResetTimer);
        copyResetTimer = window.setTimeout(function () {
          copyLabelEl.textContent = originalText;
        }, 1600);
      }

      function performCopy(e) {
        e.preventDefault();
        var code = copyBtn.getAttribute('data-code');
        if (!code) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopied, function () {});
        } else {
          var textarea = document.createElement('textarea');
          textarea.value = code;
          textarea.style.position = 'fixed';
          document.body.appendChild(textarea);
          textarea.select();
          try {
            document.execCommand('copy');
            showCopied();
          } catch (err) {}
          document.body.removeChild(textarea);
        }
      }

      copyBtn.addEventListener('click', performCopy);
    }

    if (button) {
      button.addEventListener('click', function () {
        var picked = checked();
        if (!picked.length || button.disabled) return;

        button.disabled = true;

        var drawer = document.querySelector('cart-drawer');
        var canRender = !!(drawer && typeof drawer.renderContents === 'function');
        var sectionIds = ['cart-icon-bubble'];
        if (canRender && typeof drawer.getSectionsToRender === 'function') {
          sectionIds = drawer.getSectionsToRender().map(function (section) {
            return section.id;
          });
        }

        fetch('/cart/add.js', {
          method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
            items: picked.map(function (input) {
              return { id: Number(input.dataset.variant), quantity: 1 };
            }),
            sections: sectionIds.join(','),
            sections_url: window.location.pathname
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.json();
          })
          .then(function (data) {
            button.textContent = strings.added;
            if (canRender && data && data.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            }
            window.setTimeout(function () {
              button.disabled = false;
              sync();
            }, 2000);
          })
          .catch(function () {
            button.disabled = false;
            sync();
          });
      });
    }

    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-ufc-fbt]').forEach(function (root) {
      initFbt(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support for Shopify Theme Editor live reloads
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ufc-fbt]') || (e.target.matches('[data-ufc-fbt]') ? e.target : null);
    if (root) {
      root.removeAttribute('data-ufc-bound');
      initFbt(root);
    }
  });
})();